export default __webpack_public_path__ + "static/media/IMG_4051.732dd1fa.JPG";